import React from 'react';
import { motion } from 'framer-motion';

const additionalServices = [
  "Digital Transformation Consulting",
  "IT Consulting",
  "Business Process Optimization",
  "API Development & Integrations",
  "Payment Gateway Integration",
  "CRM Integration",
  "ERP Integration",
  "Booking System Development",
  "Customer Portal Development",
  "Dashboard & Analytics Development",
  "Database Design & Optimization",
  "Custom Software Development",
  "Mobile App Backend Development",
  "Third-Party API Integration",
  "Website Speed Optimization",
  "Accessibility (WCAG) Improvements",
  "Website Audits",
  "Technical Documentation",
  "Training & Knowledge Transfer"
];

const AdditionalServices = () => {
  return (
    <section className="py-24 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 tracking-tight">Additional Professional Services</h2>
          <p className="text-slate-500 text-lg">Positioning HostFig as your full-service long-term digital partner.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-4">
          {additionalServices.map((service, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.03 }}
              className="flex items-center gap-4 py-3 border-b border-slate-50"
            >
              <div className="w-1.5 h-1.5 rounded-full bg-blue-500"></div>
              <span className="text-slate-700 font-medium text-[15px]">{service}</span>
            </motion.div>
          ))}
        </div>

        <div className="mt-24 text-center">
          <button className="bg-brand-gradient text-white px-12 py-5 rounded-full font-bold text-lg shadow-xl shadow-blue-600/20 hover:scale-[1.02] transition-transform">
            Request a Tailored Proposal
          </button>
        </div>
      </div>
    </section>
  );
};

export default AdditionalServices;